import(/* webpackMode: "eager" */ "/app/src/app/voyage-planner/(with-header)/@footer/default.tsx");
